import { getFinanceDataFromStore } from '../../utils';
export const getEventAction = (ctaType, ctaLink, linkTarget) => {
    let eventAction = '';
    switch (ctaType) {
        case 'phone':
        case 'central-customer-hotline':
            eventAction = 'call';
            break;
        case 'details':
            eventAction = ctaLink && ctaLink.includes(getCurrentDomain()) ? 'internal_link' : 'exit_link';
            break;
        case 'ecom':
            eventAction = ctaLink && ctaLink.includes(getCurrentDomain()) ? 'internal_link' : 'exit_link';
            break;
        case 'liveDemo':
        case 'liteReservation':
        case 'reserve':
        case 'reservation':
            eventAction = 'exit_link';
            break;
        case 'contact':
        case 'nws':
        case 'bevAgency':
            eventAction =
                ctaLink && (ctaLink.includes(getCurrentDomain()) || linkTarget === 'open-in-layer')
                    ? 'content'
                    : 'exit_link';
            break;
        case 'finance-checkout':
            eventAction = !ctaLink ? 'content' : 'exit_link';
            break;
        case 'leasing':
        case 'dealer':
        case 'financeInfo':
        case 'whatsApp':
        case 'financeOptions':
            eventAction = 'internal_link';
            break;
        case 'glc-cash-checkout':
        case 'glc-financing-checkout':
            eventAction = 'content';
            break;
        default:
            if (ctaLink && ctaLink.includes(getCurrentDomain())) {
                eventAction = 'internal_link';
                break;
            }
            eventAction = 'exit_link';
    }
    return eventAction;
};
const getCurrentDomain = () => {
    return window ? window.location.origin : '';
};
const getTargetURL = (linkURL, vehicleID) => {
    if (linkURL) {
        if (linkURL.includes('{{sc_vehicle_id}}')) {
            linkURL = linkURL.replace('{{sc_vehicle_id}}', vehicleID);
        }
        return getCurrentDomain() && !linkURL.includes('http') && !linkURL.includes(getCurrentDomain())
            ? `${getCurrentDomain()}${linkURL}`
            : linkURL;
    }
    return '';
};
export const getEventName = (ctaType, target, btnName, productType) => {
    let eventName = '';
    switch (ctaType) {
        case 'contact':
        case 'nws':
        case 'bevAgency':
            eventName = 'vtp contact';
            if (target === 'open-in-layer')
                eventName = 'vtp contact - layer open';
            break;
        case 'leasing':
            eventName = 'vtp click on leasing offer';
            break;
        case 'ecom':
            eventName = 'vtp click on oneaudi shop';
            break;
        case 'liveDemo':
            eventName = 'vtp click on live consulting';
            break;
        case 'liteReservation':
            eventName = 'vtp click on vehicle lite reservation';
            break;
        case 'reserve':
        case 'reservation':
            eventName = 'vtp click on vehicle reservation';
            break;
        case 'dealer':
            eventName = 'vtp carInfo - click on dealer details';
            break;
        case 'finance-checkout':
            eventName = `vtp ${btnName} request financing`;
            break;
        case 'financeInfo':
            eventName = 'vtp click on additional finance infos';
            break;
        case 'financeOptions':
            eventName = 'vtp change rate - layer open';
            break;
        case 'phone':
        case 'central-customer-hotline':
            eventName = 'vtp call dealer';
            break;
        case 'details':
            eventName = 'vtp results - go to detail page';
            break;
        case 'whatsApp':
            eventName = 'vtp carInfo - contact via whats app';
            break;
        case 'glc-cash-checkout':
            eventName = 'vtp click to purchase cash';
            break;
        case 'glc-financing-checkout':
            eventName = `vtp click to request ${productType}`;
            break;
        default:
            eventName = 'vtp click on cta';
    }
    return eventName;
};
export const getElementName = (ctaType, ctaVariant) => {
    let elementName = '';
    switch (ctaType) {
        case 'dealer':
            elementName = 'text link';
            break;
        case 'financeInfo':
            elementName = 'icon';
            break;
        case 'financeOptions':
            elementName = 'text link';
            break;
        case 'phone':
        case 'central-customer-hotline':
            elementName = ctaVariant ? 'button' : 'text link';
            break;
        case 'whatsApp':
            elementName = 'text link';
            break;
        default:
            elementName = 'button';
    }
    return elementName;
};
export const trackCTAClick = (trackingService, link, vehicleID) => {
    var _a, _b, _c;
    if (trackingService) {
        trackingService.track({
            event: {
                eventInfo: {
                    eventAction: getEventAction(link.type, link.url, link === null || link === void 0 ? void 0 : link.target),
                    eventName: getEventName(link.type, link.target),
                },
                attributes: {
                    label: (((_a = link === null || link === void 0 ? void 0 : link.url) === null || _a === void 0 ? void 0 : _a.includes('tel:')) && ((_b = link === null || link === void 0 ? void 0 : link.url) === null || _b === void 0 ? void 0 : _b.replace('tel:', ''))) || (link === null || link === void 0 ? void 0 : link.label),
                    componentName: 'vtp-carInfo',
                    elementName: getElementName(link.type, link.variant),
                    targetURL: (((_c = link === null || link === void 0 ? void 0 : link.url) === null || _c === void 0 ? void 0 : _c.includes('tel:')) && (link === null || link === void 0 ? void 0 : link.url.replace('tel:', ''))) ||
                        getTargetURL(link === null || link === void 0 ? void 0 : link.url, vehicleID) ||
                        '',
                    clickID: '',
                    value: link.variant === '' ? '' : `${link.variant} button`,
                    pos: '',
                },
            },
        });
    }
};
export const trackClick = (trackingService, link, variant, componentName, vehicleID, trackingCode, btnName) => {
    var _a, _b, _c, _d;
    if (trackingService) {
        const clickID = link.type === 'custom' ? (trackingCode !== null && trackingCode !== void 0 ? trackingCode : '') : '';
        trackingService.track({
            event: {
                eventInfo: {
                    eventAction: getEventAction(link.type, link.url, link === null || link === void 0 ? void 0 : link.target),
                    eventName: getEventName(link.type, link.target, btnName),
                },
                attributes: {
                    label: (((_a = link === null || link === void 0 ? void 0 : link.url) === null || _a === void 0 ? void 0 : _a.includes('tel:')) && ((_b = link === null || link === void 0 ? void 0 : link.url) === null || _b === void 0 ? void 0 : _b.replace('tel:', ''))) || (link === null || link === void 0 ? void 0 : link.label),
                    componentName,
                    elementName: getElementName(link.type, variant),
                    targetURL: link.type !== 'finance-checkout'
                        ? (((_c = link === null || link === void 0 ? void 0 : link.url) === null || _c === void 0 ? void 0 : _c.includes('tel:')) && ((_d = link === null || link === void 0 ? void 0 : link.url) === null || _d === void 0 ? void 0 : _d.replace('tel:', ''))) ||
                            getTargetURL(link === null || link === void 0 ? void 0 : link.url, vehicleID) ||
                            ''
                        : '',
                    clickID,
                    value: `${variant} button`,
                    pos: '',
                },
            },
        });
    }
};
export const trackGroupLeanCheckoutClick = (trackingService, navigationService, link, variant, componentName, vehicle, logger) => {
    var _a, _b, _c, _d, _e;
    try {
        if (trackingService) {
            const clickID = '';
            let targetUrl = '';
            if (navigationService) {
                targetUrl = (_a = navigationService.navigateTo('ecommerce:checkout', {})) === null || _a === void 0 ? void 0 : _a.createHref();
                if (targetUrl && targetUrl.startsWith('/') && typeof window !== 'undefined') {
                    targetUrl = `https://${window.location.hostname}${targetUrl}`;
                }
            }
            const financeData = getFinanceDataFromStore(vehicle);
            let financeType = '';
            if (financeData) {
                const financeProduct = ((_c = (_b = financeData === null || financeData === void 0 ? void 0 : financeData.financeRequestData) === null || _b === void 0 ? void 0 : _b.Request) === null || _c === void 0 ? void 0 : _c.Product)
                    ? (_e = (_d = financeData === null || financeData === void 0 ? void 0 : financeData.financeRequestData) === null || _d === void 0 ? void 0 : _d.Request) === null || _e === void 0 ? void 0 : _e.Product
                    : financeData === null || financeData === void 0 ? void 0 : financeData.defaultProductData;
                financeType = financeProduct['@Type'];
            }
            let productType = '';
            switch (financeType) {
                case 'Lease':
                    productType = 'leasing';
                    break;
                case 'Credit':
                    productType = 'credit';
                    break;
                default:
                    productType = 'financing';
            }
            trackingService.track({
                event: {
                    eventInfo: {
                        eventAction: getEventAction(link.type, link.url, link === null || link === void 0 ? void 0 : link.target),
                        eventName: getEventName(link.type, link.target, '', productType),
                    },
                    attributes: {
                        label: link.label,
                        componentName,
                        elementName: getElementName(link.type, variant),
                        targetURL: targetUrl,
                        clickID,
                        value: `${variant} button`,
                        pos: '',
                    },
                },
            });
        }
    }
    catch (e) {
        logger.error(e);
    }
};
export const trackRecalculateClick = (trackingService, label) => {
    if (trackingService) {
        trackingService.track({
            event: {
                eventInfo: {
                    eventAction: 'calculate',
                    eventName: 'vtp finance calculation',
                },
                attributes: {
                    componentName: 'vtp-carInfo',
                    label,
                    targetURL: '',
                    clickID: '',
                    elementName: 'button',
                    value: '',
                    pos: '',
                },
            },
        });
    }
};
export const trackUpdateClick = (trackingService, label) => {
    if (trackingService) {
        trackingService.track({
            event: {
                eventInfo: {
                    eventAction: 'content',
                    eventName: 'vtp apply finance calculation',
                },
                attributes: {
                    componentName: 'vtp-carInfo',
                    label,
                    targetURL: '',
                    clickID: '',
                    elementName: 'button',
                    value: '',
                    pos: '',
                },
            },
        });
    }
};
export const trackDropdownChanges = (trackingService, value, label) => {
    if (trackingService) {
        trackingService.track({
            event: {
                eventInfo: {
                    eventAction: 'content',
                    eventName: 'vtp recalculate finance calculation',
                },
                attributes: {
                    componentName: 'vtp-carInfo',
                    label,
                    targetURL: '',
                    clickID: '',
                    elementName: 'button',
                    value,
                    pos: '',
                },
            },
        });
    }
};
export const trackLayerOpen = (trackingService, eventName, pageID) => {
    if (trackingService) {
        trackingService.track({
            event: {
                eventInfo: {
                    eventAction: 'view_change',
                    eventName,
                },
                attributes: {
                    componentName: 'vtp-carInfo',
                    label: '',
                    targetURL: '',
                    clickID: '',
                    elementName: '',
                    value: '',
                    pos: '',
                },
            },
            componentUpdate: {
                page: {
                    pageInfo: {
                        pageID,
                    },
                },
            },
        });
    }
};
export const trackLayerClose = (trackingService) => {
    if (trackingService) {
        trackingService.track({
            event: {
                eventInfo: {
                    eventAction: 'content',
                    eventName: 'vtp carInfo - close financing layer',
                },
                attributes: {
                    componentName: 'vtp-carInfo',
                    label: '',
                    targetURL: '',
                    clickID: '',
                    elementName: 'other',
                    value: '',
                    pos: '',
                },
            },
            componentUpdate: {
                page: {
                    pageInfo: {
                        pageID: '',
                    },
                },
            },
        });
    }
};
